import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { FuncionarioService } from 'src/app/services/FuncionarioService/funcionario.service';
import { MotoristaExternoService } from 'src/app/services/MotoristaExternoService/motoristaExterno.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.scss']
})
export class EsqueciSenhaComponent {
  readonly brand = BRAND;
  form: FormGroup = this._inicializarFormulario();
  type: string = 'password';
  isLengthValid = false;
  hasNumber = false;
  hasLowercase = false;
  hasUppercase = false;
  hasSpecialChar = false;
  passwordsMatch = false;
  isValid = false;
  activeRoute: string = '';
  title: string = 'Alterar senha';
  model: any = {
    email: '',
    password: '',
    remember: false
  };
  token: string = '';
  isLoading: boolean = false;

  constructor(
    private authService: AuthService,
    private motoristaExternoService: MotoristaExternoService,
    private empresaService: EmpresaService,
    private funcionarioService: FuncionarioService,
    @Inject(Router) private router: Router,
    @Inject(ChangeDetectorRef) private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  onSubmit() {
    const userType = this.authService.getCurrentUserType();

    if (userType === 'PJ') {
      this.postarDadosEmpresa();
      return;
    }

    if (userType === 'FUNC') {
      this.postarDadosFuncionario();
      return;
    }

    this.postarDadosMotoristaExterno();
  }

  postarDadosEmpresa() {
    const senha = this.form.controls['TX_SENH'].value;
    this.isLoading = true;
    this.empresaService.patchEmpresaRestSenha(this.token, senha).subscribe(
      response => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Senha atualizada com sucesso!',
          'success',
          true,
          false,
          { confirmButtonText: 'Ok', confirmButtonColor: 'green' },
          () => {
            this.isLoading = false;
            this.router.navigate(['login']);
          }
        );
      },
      error => {
        this.isLoading = false;
        console.error('Erro ao alterar a senha.', error);
      }
    );
  }

  postarDadosFuncionario() {
    const senha = this.form.controls['TX_SENH'].value;
    this.isLoading = true;
    this.funcionarioService.patchFuncionarioResetSenha(this.token, senha).subscribe(
      response => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Senha atualizada com sucesso!',
          'success',
          true,
          false,
          { confirmButtonText: 'Ok', confirmButtonColor: 'green' },
          () => {
            this.isLoading = false;
            this.router.navigate(['login']);
          }
        );
      },
      error => {
        this.isLoading = false;
        console.error('Erro ao alterar a senha.', error);
      }
    );
  }

  postarDadosMotoristaExterno() {
    const senha = this.form.controls['TX_SENH'].value;
    this.isLoading = true;
    this.motoristaExternoService
      .PacthMotoristaExternoResetSenha(this.token, senha)
      .subscribe(
        response => {
          this.swalAlert.showAlert(
            'Sucesso!',
            'Senha atualizada com sucesso!',
            'success',
            true,
            false,
            { confirmButtonText: 'Ok', confirmButtonColor: 'green' },
            () => {
              this.isLoading = false;
              this.router.navigate(['login']);
            }
          );
        },
        error => {
          this.isLoading = false;
          console.error('Erro ao alterar a senha.', error);
        }
      );
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_SENH: ['', [Validators.required]],
      TX_SENH_CNFRM: ['', [Validators.required]]
    });
    return form;
  }

  public onBack() {
    this.router.navigate(['login']);
  }

  confirmacaoSenha() {
    const senha = this.form.controls['TX_SENH'].value;
    const novaSenha = this.form.controls['TX_SENH_CNFRM'].value;

    this.isLengthValid = senha.length >= 8;
    this.hasNumber = /\d/.test(senha);
    this.hasLowercase = /[a-z]/.test(senha);
    this.hasUppercase = /[A-Z]/.test(senha);
    this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
    this.passwordsMatch = senha === novaSenha;

    if (
      this.isLengthValid &&
      this.hasNumber &&
      this.hasLowercase &&
      this.hasUppercase &&
      this.hasSpecialChar &&
      this.passwordsMatch
    ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }
}
